// extracted by mini-css-extract-plugin
export default {"container":"CopyCellRender_container__8gcKt","copied":"CopyCellRender_copied__wftBS","button":"CopyCellRender_button__Ny8dg"};